import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../../TagNew';

import { tagThemeSmall } from '../../tag_theme';

interface IMultiSelectionParamTagItemProps<TParamTag> {
  tag: TParamTag;
  paramsDescription?: string;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const getMultiSelectionParamTagItem = <TParamType, TParamTag extends { value: TParamType }>(
  // tslint:disable-next-line:no-any
  paramTypesNamesMap: any,
) => (props: IMultiSelectionParamTagItemProps<TParamTag>) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {/* tslint:disable-next-line:prefer-template */}
      {paramTypesNamesMap[props.tag.value] + ' ' + (props.paramsDescription || '')}
    </TagComponent>
  );
};
